import React, { useEffect, useState } from 'react';
import ButtonCustom from '../../../../common/__deprecated__/button-custom';
import Card from '../../../../common/card';
import { ReactComponent as AffiliationsIcon } from '../../../../../assets/icons/affiliations.svg';
import { ReactComponent as CheckGreenIcon } from '../../../../../assets/icons/check-green.svg';
import { ReactComponent as ClockYellowIcon } from '../../../../../assets/icons/clock-yellow.svg';
import { ReactComponent as TransactionIcon } from '../../../../../assets/icons/transactions.svg';
import ShareLink from '../share-link';
import './styles.scss';
import { useDashboard } from '../../../../../store/dashboard';
import Table from '../../../../common/table';
import { useTransactions } from '../../../../../store/transactions';
import StatsCircularBar from '../stats-circular-bar';
import { Box, Divider, useMediaQuery } from '@mui/material';
import Parser from 'html-react-parser';
import l from '../../../../../lang';
import { EmptyStats } from '../empty-stats';
import ChipStatus from '../../../../common/chip-status';
import DialogConfirm from '../../../../common/confirm/dialog-confirm';
import CardConfirm from '../../../../common/confirm/card-confirm';
import ShareLinkModal from '../share-link-modal';

const Affiliations = () => {
  const { merchantMe } = useDashboard();
  const { affiliationsInfo, getAffiliationsInfo } = useTransactions();
  const isTabletMobile = useMediaQuery('(max-width:768px)');

  const [urlLink, setUrlLink] = useState('');
  const [show100UsdDialog, setShow100UsdDialog] = useState(false);
  const [showShareLinkModal, setShowShareLinkModal] = useState(false);

  useEffect(() => {
    getAffiliationsInfo();
  }, []);

  useEffect(() => {
    const mid = merchantMe?.id;
    if (!mid) return;
    const origin = window.location.origin;
    const ref = btoa(`mid:${mid}`);

    setUrlLink(`${origin}/signup?ref=${ref}&utm_source=affiliate&utm_campaign=affiliate-ao&utm_term=${mid}`);
  }, [merchantMe]);

  const getAccountStatus = (kycLevel: number, kycReview: boolean) => {
    const level = kycLevel >= 2 ? 2 : kycLevel;

    if (level == 2 && !kycReview) {
      return `KYC 2 Ok`;
    }

    return l('common.pending');
  };

  const handleShareLink = () => {
    if (affiliationsInfo.data?.enabled) {
      setShowShareLinkModal(true);
    } else {
      setShow100UsdDialog(true);
    }
  };

  const handleOnCopy = () => {
    if (!affiliationsInfo.data?.enabled) {
      navigator.clipboard.writeText('');
      setShow100UsdDialog(true);
    }
  };

  const getAffiliateAmount = (amount: number) => {
    if (amount > 0) {
      return `${merchantMe?.functionalCurrency} ${amount}`;
    }

    return `---`;
  };

  return (
    <div>
      <Card>
        <div className="affiliations-card">
          <div className="affiliations-card__win">
            <span className="affiliations-card__win__icon">
              <AffiliationsIcon />
            </span>
            <div className="affiliations-card__win__desc">
              <p className="affiliations-card__win__desc__bold">{Parser(l('affiliations.affiliates.header'))}</p>
              <p>{Parser(l('affiliations.affiliates.desc'))}</p>
            </div>
          </div>
          <div className="affiliations-card__link">
            <div className="affiliations-card__link__copy">
              <ShareLink url={urlLink} validReferrer={affiliationsInfo.data?.enabled} onCopy={handleOnCopy} />
            </div>
          </div>
        </div>
      </Card>

      {show100UsdDialog && (
        <DialogConfirm onClose={() => setShow100UsdDialog(false)}>
          <CardConfirm
            onClose={() => setShow100UsdDialog(false)}
            headline={l('affiliations.affiliates.100UsdDialog.title')}
            description={l('affiliations.affiliates.100UsdDialog.description')}
            confirmChildren={l('common.confirm')}
            level={'info'}
          />
        </DialogConfirm>
      )}

      {showShareLinkModal && <ShareLinkModal link={urlLink} onClose={() => setShowShareLinkModal(false)} />}

      <h3>{l('affiliations.affiliates.resume')}</h3>
      <Table
        emptyBody={<></>}
        headers={[
          <span>{l('affiliations.affiliates.resume.headers.totalReferrals')}</span>,
          <span className="active-icon">{l('affiliations.affiliates.resume.headers.actives')}</span>,
          <span>{l('affiliations.affiliates.resume.headers.accumulatedCredits')}</span>,
          <span>{l('affiliations.affiliates.resume.headers.availableCredits')}</span>,
          <span>{l('affiliations.affiliates.resume.headers.creditsToExpire')}</span>,
        ]}
        body={
          affiliationsInfo.data?.enabled
            ? [
                [
                  <span>{affiliationsInfo.data.resume.totalAffiliates}</span>,
                  <span>{affiliationsInfo.data.resume.totalActiveAffiliates}</span>,
                  <span>{getAffiliateAmount(affiliationsInfo.data.resume.totalEarnedCredits)}</span>,
                  <span>{getAffiliateAmount(affiliationsInfo.data.resume.totalAvailableCredits)}</span>,
                  <span>
                    {affiliationsInfo.data.resume.creditsToExpireIn7Days > 0
                      ? `${getAffiliateAmount(affiliationsInfo.data.resume.creditsToExpireIn7Days)} ${l('common.in')} 7 ${l(
                          'common.days'
                        )}`
                      : `---`}
                  </span>,
                ],
              ]
            : [[<span>---</span>, <span>---</span>, <span>---</span>, <span>---</span>]]
        }
      />

      <h3>{l('affiliations.affiliates.affiliatesTable')}</h3>
      <Table
        emptyBody={<></>}
        headers={[
          <span>{l('affiliations.affiliates.affiliatesTable.headers.number')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.email')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.accountStatus')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.firstTransactionDate')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.90daysAmount')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.earnedCredits')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.appliedCredits')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.totalCredits')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.status')}</span>,
          <span>{l('affiliations.affiliates.affiliatesTable.headers.remainingTime')}</span>,
        ]}
        body={
          affiliationsInfo.data?.enabled
            ? affiliationsInfo.data.affiliates.map((affiliate, index) => [
                <span>{String(index + 1).padStart(2, '0')}</span>,
                <span>{affiliate.email}</span>,
                <span className="with-icon">
                  {affiliate.kycLevel < 4 || affiliate.kycReview ? <ClockYellowIcon /> : <CheckGreenIcon />}
                  {getAccountStatus(affiliate.kycLevel, affiliate.kycReview)}
                </span>,
                <span>{affiliate.firstTransactionDate ?? '---'}</span>,
                <span>{getAffiliateAmount(affiliate.tpvLast90Days)}</span>,
                <span>{getAffiliateAmount(affiliate.earnedCredits)}</span>,
                <span>{getAffiliateAmount(affiliate.appliedCredits)}</span>,
                <span className="with-icon">
                  <TransactionIcon />
                  {getAffiliateAmount(affiliate.totalCredits)}
                </span>,
                <span>
                  <ChipStatus
                    status={affiliate.status}
                    text={l(`affiliations.affiliates.affiliatesTable.${affiliate.status}`)}
                  />
                </span>,
                <span>
                  {affiliate.remainingDays > 0 ? `${affiliate.remainingDays} ${l('common.days')}` : <span>---</span>}
                </span>,
              ])
            : [
                [
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                  <span>---</span>,
                ],
              ]
        }
      />

      <div className="invite-button">
        <ButtonCustom
          text={`+ ${String(l('affiliations.affiliates.invite')).toUpperCase()}`}
          fullWidth
          variant="contained"
          onClick={handleShareLink}
        ></ButtonCustom>
      </div>

      <h3>{l('affiliations.affiliates.yourStats')}</h3>
      <Card>
        {affiliationsInfo.data?.enabled && (
          <Box className="affiliations-stats">
            <StatsCircularBar
              descTitle={l('affiliations.affiliates.stats.activeAffiliates')}
              descValue={`${Number(affiliationsInfo.data.stats.totalActiveAffiliates)}`}
              percentage={Number(
                (
                  (affiliationsInfo.data.stats.totalActiveAffiliates /
                    (affiliationsInfo.data.stats.totalAffiliates != 0 ? affiliationsInfo.data.stats.totalAffiliates : 1)) *
                  100
                ).toFixed(2)
              )}
            ></StatsCircularBar>
            {!isTabletMobile && <Divider orientation="vertical" flexItem sx={{ marginRight: '20px' }} />}
            <StatsCircularBar
              descTitle={l('affiliations.affiliates.stats.accumulate')}
              descValue={merchantMe?.functionalCurrency + ' ' + affiliationsInfo.data.stats.totalEarnedCredits}
              percentage={43.37}
            ></StatsCircularBar>
            {!isTabletMobile && <Divider orientation="vertical" flexItem sx={{ marginRight: '20px' }} />}
            <StatsCircularBar
              descTitle={l('affiliations.affiliates.stats.usage')}
              descValue={merchantMe?.functionalCurrency + ' ' + affiliationsInfo.data.stats.totalAppliedCredits}
              percentage={Number(
                (
                  (affiliationsInfo.data.stats.totalAppliedCredits /
                    (affiliationsInfo.data.stats.totalEarnedCredits != 0
                      ? affiliationsInfo.data.stats.totalEarnedCredits
                      : 1)) *
                  100
                ).toFixed(2)
              )}
            ></StatsCircularBar>
          </Box>
        )}
        {!affiliationsInfo.data?.enabled && <EmptyStats />}
      </Card>
    </div>
  );
};

export default Affiliations;
